import * as CXClientLogger from "Common/CXClientLogger";
import BindExecModule from "Common/BindExecModule";
import * as ExternalAddSellerUser from "./Modules/ExternalAddSellerUser";

CXClientLogger.AttachLogger();//needs to be before page load to log all errors

var CXExternalAddSellerUserApp = Mn.Application.extend({
    initialize: function (options) { },
    onStart: function (options) {
        Mn.setRenderer(Mn.TemplateCache.render); //bring back the 2x default renderer that allows us to use the id of a script containing a template
        ExternalAddSellerUser.bindExternalAddSellerUser();
    }
});

var CXExternalAddSellerUserApp = window.CXExternalAddSellerUserApp = new CXExternalAddSellerUserApp();
export default CXExternalAddSellerUserApp;